{
  "name": "portailrh-front",
  "version": "3.0.6-rc.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:local": "npm run prebuild && ng build --configuration=local",
    "build:dev": "npm run prebuild && ng build --configuration=dev",
    "build:rec": "npm run prebuild && ng build --configuration=rec",
    "build:prd": "npm run prebuild && ng build --configuration=prd",
    "test": "ng test",
    "lint": "ng lint",
    "prebuild": "copyfiles -f --verbose \"./src/resources/orgchart.js\" \"./node_modules/@balkangraph/orgchart.js\""
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.17",
    "@angular/common": "21.2.17",
    "@angular/compiler": "21.2.17",
    "@angular/core": "21.2.17",
    "@angular/forms": "21.2.17",
    "@angular/platform-browser": "21.2.17",
    "@angular/router": "21.2.17",
    "@balkangraph/orgchart.js": "^8.16.21",
    "@ng-select/ng-select": "^21.8.2",
    "@swimlane/ngx-datatable": "^24.0.1",
    "ag-grid-angular": "^35.3.1",
    "ag-grid-community": "^35.3.1",
    "ag-grid-enterprise": "^35.3.1",
    "angular-oauth2-oidc": "^20.0.3",
    "angular-oauth2-oidc-jwks": "^17.0.2",
    "bootstrap": "^5.3.3",
    "bootstrap-icons": "^1.11.3",
    "dayjs": "^1.11.13",
    "file-saver": "^2.0.5",
    "ngx-bootstrap": "^21.2.1",
    "ngx-device-detector": "^11.0.0",
    "ngx-spinner": "^21.1.0",
    "ngx-toastr": "^20.0.5",
    "ngx-webstorage": "^21.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.6.2",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "18.4.3",
    "@angular-eslint/eslint-plugin": "18.4.3",
    "@angular-eslint/eslint-plugin-template": "18.4.3",
    "@angular-eslint/schematics": "18.4.3",
    "@angular-eslint/template-parser": "18.4.3",
    "@angular/build": "21.2.17",
    "@angular/cli": "21.2.17",
    "@angular/compiler-cli": "21.2.17",
    "@angular/localize": "21.2.17",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "~4.3.5",
    "@types/node": "22.19.19",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "angular-eslint": "^18.4.3",
    "copyfiles": "^2.4.1",
    "eslint": "8.57.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.9.4",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "typescript": "5.9.3"
  },
  "optionalDependencies": {
    "@nx/nx-darwin-arm64": "18.0.4",
    "@nx/nx-darwin-x64": "18.0.4",
    "@nx/nx-linux-x64-gnu": "18.0.4",
    "@nx/nx-win32-x64-msvc": "18.0.4"
  }
}
